import { render, staticRenderFns } from "./secondLayout.vue?vue&type=template&id=a5089452&scoped=true"
import script from "./secondLayout.vue?vue&type=script&lang=js"
export * from "./secondLayout.vue?vue&type=script&lang=js"
import style0 from "./secondLayout.vue?vue&type=style&index=0&id=a5089452&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5089452",
  null
  
)

export default component.exports